<div class="modal-header">
    <button type="button" class="close modal-x-button pull-right" (click)="activeModal.dismiss()">
        <pureui-svg class="pstg-action-icon" svg="x-action.svg" height="12"></pureui-svg>
    </button>
</div>
<div class="modal-body">
    <div class="icon">
        <pureui-svg class="check-mark-icon" svg="check_mark.svg" height="31"></pureui-svg>
        <pureui-svg class="confirmation-icon" svg="confirmation-icon.svg" height="80"></pureui-svg>
    </div>
    <hive-label class="confirmed-label" label="{{ title }}"></hive-label>
    <hive-label class="confirmed-message" label="{{ description }}">
        <span *ngIf="canTrackOrder">
            >You can track this request via the
            <a routerLink="/services/servicecatalog/orders" (click)="clickOrdersPage()">Orders Page</a>
        </span>
    </hive-label>
    <ng-container *ngIf="showCdlAgentRecommendation; else showOldButton">
        <hive-label
            class="cdl-agent-recommendation-title"
            label="Speed up your next capacity expansion"
            size="medium"
        ></hive-label>
        <hive-label
            class="cdl-agent-recommendation-text"
            label="Install/Update the Entitlement Agent now to enable faster, automated capacity expansions. It's a one-time step that removes friction later — no need to install it when time is critical."
            size="small"
        ></hive-label>
        <div class="cdl-button-container">
            <hive-button label="Maybe Later" emphasis="secondary" (click)="confirmedRequest()"></hive-button>
            <hive-button label="Install Now" (click)="navigateToEmsPage()"></hive-button>
        </div>
    </ng-container>
    <ng-template #showOldButton>
        <button class="btn btn-primary" (click)="confirmedRequest()">OK</button>
    </ng-template>
</div>
